import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  RichTextSection,
  richTextHasContent,
  RichTextRender,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const messages = defineMessages({
  indirizzo_more_info: {
    id: 'indirizzo_more_info',
    defaultMessage: 'Altre informazioni',
  },
  other_references: {
    id: 'other_references',
    defaultMessage: 'Altri riferimenti',
  },
  contact_person: {
    id: 'contact_person',
    defaultMessage: 'Referente',
  },
  activities: {
    id: 'activities',
    defaultMessage: 'Attività',
  },
  specialization: {
    id: 'specialization',
    defaultMessage: 'Specialità',
  },
});

const IndirizzoMoreInfo = ({ content }) => {
  const intl = useIntl();
  return (
    <>
      {(richTextHasContent(content.other_references) ||
        richTextHasContent(content.contact_person) ||
        richTextHasContent(content.activities) ||
        richTextHasContent(content.specialization)) && (
        <RichTextSection
          tag_id="indirizzo_more_info"
          title={intl.formatMessage(messages.indirizzo_more_info)}
        >
          {richTextHasContent(content.other_references) && (
            <div className="mb-4">
              <h3 className="h5">
                {intl.formatMessage(messages.other_references)}
              </h3>
              <RichTextRender data={content.other_references} serif={false} />
            </div>
          )}
          {richTextHasContent(content.contact_person) && (
            <div className="mb-4">
              <h3 className="h5">
                {intl.formatMessage(messages.contact_person)}
              </h3>
              <RichTextRender data={content.contact_person} serif={false} />
            </div>
          )}
          {richTextHasContent(content.activities) && (
            <div className="mb-4">
              <h3 className="h5">{intl.formatMessage(messages.activities)}</h3>
              <RichTextRender data={content.activities} serif={false} />
            </div>
          )}
          {richTextHasContent(content.specialization) && (
            <div className="mb-4">
              <h3 className="h5">
                {intl.formatMessage(messages.specialization)}
              </h3>
              <RichTextRender data={content.specialization} serif={false} />
            </div>
          )}
        </RichTextSection>
      )}
    </>
  );
};

export default IndirizzoMoreInfo;
